<p-dialog
  [header]="'Common.Button.Crop' | translate"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  [closable]="false"
  appendTo="body"
  (onHide)="close()"
>
  <ng-template pTemplate="content">
    <div *ngIf="isLoading" class="pdf-crop-loading p-text-center p-p-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
    </div>

    <div *ngIf="loadError" class="p-error p-text-center p-p-3">
      {{ 'Common.Validate.PdfLoadFailed' | translate }}
    </div>

    <!-- Step 1: 選擇要上傳的頁面 -->
    <div *ngIf="!isLoading && !loadError && pages.length && step === 'select'">
      <div class="pdf-select-toolbar p-d-flex p-ai-center p-mb-3">
        <button
          pButton
          type="button"
          [label]="'Common.Button.SelectAll' | translate"
          class="p-button-action p-button-outlined p-button-sm p-mr-2"
          (click)="selectAllPages()"
        ></button>
        <button
          pButton
          type="button"
          [label]="'Common.Button.DeselectAll' | translate"
          class="p-button-action p-button-outlined p-button-sm p-mr-3"
          (click)="deselectAllPages()"
        ></button>
        <span class="pdf-selected-count">
          {{ 'Common.Label.SelectedPages' | translate: { selected: selectedCount, total: pages.length } }}
        </span>
      </div>

      <div class="pdf-page-grid">
        <div
          *ngFor="let page of pages; let i = index"
          class="pdf-page-card"
          [class.selected]="page.included"
          (click)="togglePageIncluded(i)"
        >
          <input
            type="checkbox"
            class="page-include-checkbox"
            [checked]="page.included"
            (click)="$event.stopPropagation(); togglePageIncluded(i)"
          />
          <img [src]="page.originalBase64" alt="page {{ page.pageNumber }}" />
          <span class="page-number">{{ page.pageNumber }}</span>
        </div>
      </div>

      <small *ngIf="noPageSelectedError" class="p-error d-block mt-2">
        {{ 'Common.Validate.AtLeastOnePage' | translate }}
      </small>
    </div>

    <!-- Step 2: 針對已勾選的頁面逐頁裁切 -->
    <div *ngIf="!isLoading && !loadError && pages.length && step === 'crop'" class="pdf-crop-step">
      <div class="pdf-crop-sidebar" *ngIf="includedPages.length > 1">
        <div
          *ngFor="let item of includedPages"
          class="pdf-page-thumbnail"
          [class.active]="item.index === currentPageIndex"
          (click)="goToPage(item.index)"
        >
          <img [src]="item.page.croppedBase64 || item.page.originalBase64" alt="page {{ item.page.pageNumber }}" />
          <i *ngIf="item.page.croppedBase64" class="pi pi-check-circle cropped-badge"></i>
          <span class="page-number">{{ item.page.pageNumber }}</span>
        </div>
      </div>

      <div class="pdf-crop-main">
        <div class="pdf-cropper-container">
          <image-cropper
            *ngIf="currentPageImage"
            [imageBase64]="currentPageImage"
            [maintainAspectRatio]="false"
            [cropper]="cropperPosition"
            format="jpeg"
            (imageCropped)="onImageCropped($event)"
            (cropperReady)="onCropperReady($event)"
          ></image-cropper>
        </div>

        <button
          pButton
          type="button"
          [label]="'Common.Button.ResetCrop' | translate"
          class="p-button-text p-button-sm p-mt-2"
          (click)="resetCurrentPageCrop()"
        ></button>

        <small *ngIf="sizeError" class="p-error d-block mt-1">
          {{ 'Common.Validate.FileSizeExceed' | translate : { size: maxSizeMB } }}
        </small>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-secondary"
      [label]="'Common.Button.Cancel' | translate"
      (click)="close()"
    ></button>
    <button
      *ngIf="step === 'crop' && pages.length > 1"
      pButton
      type="button"
      class="p-button-secondary"
      [label]="'Common.Button.Back' | translate"
      (click)="backToSelect()"
    ></button>
    <button
      *ngIf="step === 'select'"
      pButton
      type="button"
      [label]="'Common.Button.Next' | translate"
      [disabled]="isLoading || loadError || !hasIncludedPage"
      (click)="nextStep()"
    ></button>
    <button
      *ngIf="step === 'crop'"
      pButton
      type="button"
      [label]="'Confirm' | translate"
      [disabled]="isLoading || isProcessing || loadError || !hasIncludedPage"
      (click)="confirm()"
    ></button>
  </ng-template>
</p-dialog>
